import React, { useState } from "react";
import Layout from "../Componants/Layout";
import Form from "react-bootstrap/Form";
import { Col, Container, Row } from "react-bootstrap";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import AccountSuccessModal from "../Modal/ AccountSuccessModal";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";
import { companySizeOptions, companytype, LimitedCompanyOptions } from "../utils/commanFiles";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import toast from "react-hot-toast";
import CompanySizeSelect from "../../src/Componants/CompanySizeSelect"

// Yup validation schema
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  bussinessName: Yup.string().required("Business Name is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  phoneNumber: Yup.string()
    .matches(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i, 'Invalid phone number format')
    .required('Phone number is required'),
  // companyWebsite: Yup.string()
  //   .url("Invalid URL format")
  //   .required("Website is required"),
  // companySize: Yup.string().required("Company size is required"),
  companyType: Yup.string().required("Company type is required"),

  companySize: Yup.string().when('companyType', {
    is: 'LimitedCompany',
    then: (schema) => schema.required("Company size is required"),
    otherwise: (schema) => schema.notRequired()
  }),

  
});

export default function RegistrationBusiness() {
  const deviceType = localStorage.getItem("deviceType") || "";
  const fcm_token = localStorage.getItem("fcm_token") || "";
  const referId = localStorage.getItem("referId") || "";
  const [isChecked, setIsChecked] = useState(false); // State for checkbox
  const [phone, setPhone] = useState("");
  const Navigate = useNavigate();

  const initialdata = {
    name: "",
    email: "",
    bussinessName: "",
    phoneNumber: "",
    countryCode: "",
    companySize: "",
    companyType:"",
    companyWebsite: "",
    role: "Vendor",
    deviceType: deviceType,
    deviceToken: fcm_token,
    referId: referId
  };

  const userId = localStorage.getItem("userId");

  const { data: userDetails, error: userError, isLoading: userLoading } = useQuery({
    queryKey: ["userDetails", userId],
    queryFn: () => getRequest(`profile/info?id=${userId}`),
    enabled: !!userId,
  });

  const editOptions = userDetails?.data ? userDetails.data : initialdata;


  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      const modifyData = {
        name: data?.name,
        email: data?.email,
        bussinessName: data?.bussinessName,
        phoneNumber: data?.phoneNumber,
        countryCode: data?.countryCode,
        companySize: data?.companySize,
        companyType:data?.companyType,
        companyWebsite: data?.companyWebsite,
        id: userId,
        role: "Vendor",
        deviceType: deviceType,
        referId: referId,
        deviceToken: fcm_token,
      };
      localStorage.setItem("email", data?.email);
      return postRequest(`/auth/register`, modifyData);
    },
    onSuccess: (data) => {
      Navigate("/registration-password");
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  return (
    <Layout>
      <Container>
        <Row>
          <Col lg={6}>
            <div className="pre-registration">
              <div className="pre-registration-box">
                <h3 className="RegisTitle">Your Business Details</h3>
                <p>
                  Provide some more details about you and your business. You’re
                  getting closer to receiving new leads.
                </p>
                <div className="pre-registration-form">
                  <div className="h-100 m-0">
                    <h3 className="RegisTitle">More Information</h3>
                    <p>
                      Provide the following information and we’ll arrange the
                      next steps.
                    </p>
                    <Formik
                      initialValues={editOptions}
                      enableReinitialize={true}
                      validationSchema={validationSchema}
                      onSubmit={(values) => {
                        if (!isChecked) {
                          toast.error("Please accept the Terms and Conditions");
                        } else {
                          mutate(values);
                        }
                      }}
                    >
                      {({ handleSubmit, setFieldValue, values }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                          <div className="cmn-form-set">
                            <Form.Group className="mb-3" controlId="name">
                              <Form.Label>Your Name</Form.Label>
                              <Field
                                name="name"
                                type="text"
                                placeholder="Type here"
                                className="form-control"
                                onChange={(e) => {
                                  let value = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                                  value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                  setFieldValue("name", value);
                                }}
                              />
                              <ErrorMessage
                                name="name"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>

                            <Form.Group
                              className="mb-3"
                              controlId="businessName"
                            >
                              <Form.Label>Business Name</Form.Label>
                              <Field
                                name="bussinessName"
                                type="text"
                                onChange={(e) => {
                                  let value = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                                  value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                  setFieldValue("bussinessName", value);
                                }}
                                placeholder="Type here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="bussinessName"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="email">
                              <Form.Label>Account Holder Email</Form.Label>
                              <Field
                                name="email"
                                type="text"
                                placeholder="Type here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>

                            <Form.Group
                              className="mb-3"
                              controlId="phoneNumber"
                            >
                              <Form.Label>Account Holder Phone</Form.Label>
                              <PhoneInput
                                country={"gb"}
                                name="phoneNumber"
                                type="phone"
                                containerClass="PhoneInput-custom-container"
                                inputClass="PhoneInput-custom-input"
                                enableSearch={true}
                                value={values.phoneNumber ?  `+${values.countryCode}${values.phoneNumber}` :phone}
                                onChange={(phone, country) => {
                                  setPhone(phone)
                                  if(phone){
                                    setFieldValue("phoneNumber", phone.slice(country.dialCode.length))
                                    setFieldValue('countryCode', country.dialCode);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="phoneNumber"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="website">
                              <Form.Label>Company Website (Optional)</Form.Label>

                              <Field
                                name="companyWebsite"
                                type="text"
                                className="form-control"
                                placeholder="Type here"
                                onChange={(e) => {
                                  let value = e.target.value.trim();
                                  if (!value.startsWith("http://") && !value.startsWith("https://")) {
                                    setFieldValue("companyWebsite", `https://${value}`);
                                  } else {
                                    setFieldValue("companyWebsite", value);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="companyWebsite"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>

                            <Form.Group
                              className="mb-3"
                              controlId="formCompanySize"
                            >
                              <Form.Label>Company Type</Form.Label>
                              <Field
                                id="category"
                                name="companyType"
                                as="select"
                                className="form-select"
                              >
                                <option value="">
                                  Select Company type
                                </option>
                                {companytype.map((item, i) => (
                                  <option value={item.value} key={i}>
                                    {item.label}
                                  </option>
                                ))}
                              </Field>

                              <ErrorMessage
                                name="companyType"
                                component="div"
                                className="text-danger"
                              />
                            </Form.Group>


                            {values.companyType === 'LimitedCompany' &&
                              <Form.Group
                                className="mb-3"
                                controlId="formCompanySize"
                              >
                                <Form.Label>Company Size</Form.Label>
                                <Field
                                  id="category"
                                  name="companySize"
                                  as="select"
                                  className="form-select"
                                >
                                  <option value="">
                                    Select Company Size
                                  </option>
                                  {LimitedCompanyOptions.map((item, i) => (
                                    <option value={item.value} key={i}>
                                      {item.label}
                                    </option>
                                  ))}
                                </Field>


                                <ErrorMessage
                                  name="companySize"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Group>
                            }

                            <Form.Group className="mb-3 terms-conditions" controlId="terms">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) => setIsChecked(e.target.checked)}
                              />
                              <span>
                                By registering, I confirm that I accept SparkPro's{" "}
                                <Link to="/terms-and-conditions" target="_blank">
                                  Terms & Conditions
                                </Link>
                                . I have read the{" "}
                                <Link to="/privacy-policy" target="_blank">
                                  Privacy Policy{" "}
                                </Link>
                                and I am at least 18 years old.
                              </span>
                            </Form.Group>

                            <div className="registration-form-action">
                              <button
                                className="theme-btn"
                                type="button"
                                onClick={() =>
                                  Navigate("/registration-address")
                                }
                              >
                                Back
                              </button>
                              <button className="white-btn" type="submit">
                                Next
                              </button>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
